export default __webpack_public_path__ + "static/media/raise2.1a7a14c4.mp3";